var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrowSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17439 0.133375L5.44153 0.398512C5.61854 0.574257 5.61854 0.859169 5.44153 1.03491L2.27093 4.16408L21.3067 4.16408C21.557 4.16408 21.76 4.36557 21.76 4.61408V4.98908C21.76 5.23759 21.557 5.43908 21.3067 5.43908L2.27093 5.43908L5.44153 8.56824C5.61854 8.74395 5.61854 9.02886 5.44153 9.20464L5.17439 9.46978C4.99739 9.64549 4.71033 9.64549 4.53332 9.46978L0.132757 5.11978C-0.0442524 4.94403 -0.0442524 4.65912 0.132757 4.48334L4.53332 0.133339C4.71033 -0.0423698 4.99739 -0.0423698 5.17439 0.133375Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowSmall);
export default __webpack_public_path__ + "static/media/LeftArrowSmall.5f25eaae6466a45974835647c884676b.svg";
export { ForwardRef as ReactComponent };